
export default function CrimeStatsSection() {
  const stats = [
    {
      number: '180,000+',
      label: 'Vehicle Thefts Annually',
      description: 'Cars stolen across the UK every year',
      icon: 'ri-car-line'
    },
    {
      number: '493',
      label: 'Daily Vehicle Crimes',
      description: 'Average vehicle thefts per day in the UK',
      icon: 'ri-alarm-warning-line'
    },
    {
      number: '£2.1B',
      label: 'Annual Losses',
      description: 'Total cost of vehicle crime to UK economy',
      icon: 'ri-money-pound-circle-line'
    },
    {
      number: '85%',
      label: 'Prevention Rate',
      description: 'Crimes prevented with proper bollard protection',
      icon: 'ri-shield-check-line'
    }
  ];

  const regionalStats = [
    { area: 'Essex', thefts: '8,420', rate: '4.2 per 1,000' },
    { area: 'London', thefts: '45,680', rate: '5.1 per 1,000' },
    { area: 'West Midlands', thefts: '28,340', rate: '4.8 per 1,000' },
    { area: 'Greater Manchester', thefts: '22,150', rate: '3.9 per 1,000' },
    { area: 'West Yorkshire', thefts: '18,920', rate: '4.1 per 1,000' }
  ];

  return (
    <section id="stats" className="py-20 bg-black">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            UK Vehicle Crime <span className="text-yellow-500">Statistics</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            The alarming rise in vehicle crime across the UK highlights the critical need for effective security measures. Protect your property with professional bollard installations.
          </p>
        </div>

        {/* Main Statistics */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="bg-gray-900/50 backdrop-blur-sm rounded-xl p-6 border border-yellow-500/20 text-center">
              <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-black text-2xl`}></i>
              </div>
              <h3 className="text-3xl font-bold text-yellow-500 mb-2">{stat.number}</h3>
              <h4 className="text-lg font-semibold text-white mb-2">{stat.label}</h4>
              <p className="text-gray-400 text-sm">{stat.description}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Regional Statistics */}
          <div className="bg-gray-900/50 backdrop-blur-sm rounded-xl p-8 border border-yellow-500/20">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
              <i className="ri-map-pin-line text-yellow-500 mr-3"></i>
              Regional Vehicle Theft Statistics (2023)
            </h3>
            <div className="space-y-4">
              {regionalStats.map((region, index) => (
                <div key={index} className="flex justify-between items-center py-3 border-b border-gray-700 last:border-b-0">
                  <div>
                    <h4 className="text-white font-semibold">{region.area}</h4>
                    <p className="text-gray-400 text-sm">{region.rate}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-yellow-500 font-bold">{region.thefts}</p>
                    <p className="text-gray-400 text-sm">thefts</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Crime Prevention Info */}
          <div className="bg-gray-900/50 backdrop-blur-sm rounded-xl p-8 border border-yellow-500/20">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
              <i className="ri-shield-check-line text-yellow-500 mr-3"></i>
              How Bollards Prevent Crime
            </h3>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-car-line text-black text-sm"></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-2">Vehicle Ram Prevention</h4>
                  <p className="text-gray-400">Bollards create physical barriers preventing vehicles from accessing protected areas, stopping ram raids and smash-and-grab crimes.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-eye-line text-black text-sm"></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-2">Visual Deterrent</h4>
                  <p className="text-gray-400">Visible security measures deter criminals from targeting your property, reducing crime rates by up to 85%.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-time-line text-black text-sm"></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-2">Access Control</h4>
                  <p className="text-gray-400">Retractable bollards allow authorized access while maintaining security during off-hours.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-12 bg-yellow-500/10 rounded-xl p-8 border border-yellow-500/20">
          <h3 className="text-2xl font-bold text-white mb-4">Don't Become a Statistic</h3>
          <p className="text-gray-300 mb-6">Protect your property with professional bollard installation. Contact us today for a free security assessment.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-yellow-500 text-black px-8 py-3 rounded-lg font-semibold hover:bg-yellow-400 transition-colors cursor-pointer whitespace-nowrap">
              Free Security Assessment
            </button>
            <button className="border-2 border-yellow-500 text-yellow-500 px-8 py-3 rounded-lg font-semibold hover:bg-yellow-500 hover:text-black transition-colors cursor-pointer whitespace-nowrap">
              Emergency Installation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
